import { BankrollContext } from 'contexts'
import React from 'react'

export const useBankrolls = () => React.useContext(BankrollContext)
